import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingInterceptor } from '@core/interceptors/loading/loading.interceptor';
import { DataInterceptor } from '@core/interceptors/data/data.interceptor';
import { RefreshInterceptor } from '@core/interceptors/refresh/refresh.interceptor';
import { SessionInterceptor } from '@core/interceptors/session/session.interceptor';

export function createTranslateLoader(http: HttpClient){
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
    declarations: [],
    exports: [
        TranslateModule
    ],
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            isolate: false,
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        SessionInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefreshInterceptor,
            multi: true
        },
        {
            // useExisting: misma instancia que inyecta DataInterceptor;
            // con useClass el flag isLoggingOut viviría en dos objetos distintos
            provide: HTTP_INTERCEPTORS,
            useExisting: SessionInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DataInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
